import {createSlice} from '@reduxjs/toolkit';
import Api from "../utils/api_calls";
import queryString from 'query-string';
import ClientConfigurationHelper from '../configuration/ClientConfigurationHelper';

const initialState = {
    isLoading: false,
    content: [],
    keepLoading: true,
    filters:{
        p: 1,
        n: 5,
        user_id: null,
        category: null
    }
}

const contentSlice = createSlice({
    name: 'content',
    initialState,
    reducers: {
        updateAssets: (state, {payload}) => {
            const data = [...payload['hydra:member']];
            state.isLoading = false;
            state.keepLoading = data.length !== 0;
            if(state.filters.p === 1){
                state.content = data;
            }else{
                state.content = state.content.concat(data);
            }
        },
        updateFilters: (state, {payload}) => {
            state.filters = {...payload};
        },
        setIsLoading: (state, {payload = false}) => {
            state.isLoading = true;
        },
        resetAndLoadCategory(state, {payload}){
            state.content = [];
            state.keepLoading = true;
            state.isLoading = false;
            const filters = {...initialState.filters};
            filters.category = payload;
            state.filters = filters;
        },
        resetFilters(state, {payload}){
            state.content = [];
            state.keepLoading = true;
            state.isLoading = false;
            const filters = {...initialState.filters};
            filters.category = null;
            state.filters = filters;
        }
    },
})
export const {updateAssets, setIsLoading, updateFilters, resetAndLoadCategory, resetFilters} = contentSlice.actions;
export const contentSelector = state => state.content;
export default contentSlice.reducer
const buildParameters = (params, url) =>{
    const filters = {...params};
    const {isHomePage} = TVSite;
    if(!filters.hasOwnProperty('order_by') && isHomePage){
        const validValues = ['date_created', 'stats_es_views_lifetime'];
        const query = window.location.search;
        const params = queryString.parse(query);
        if (params.filter && validValues.includes(params.filter)) {
            filters.order_by = params.filter;
        } else {
            filters.order_by = 'date_created';
        }
        
    }else if(!filters.order_by){
        filters.order_by = 'date_created';
    }
    let attachSymbol = '&';
    if(!url.includes('?')){
        attachSymbol = '?';
    }
    return attachSymbol+`entity_type=video%2Cphoto&order_by=${filters.order_by}&order=desc&page=${filters.p}&per_page=${filters.n}`
}
export const getContent = (url, filters) => dispatch => {
    dispatch(setIsLoading(true));
    return Api.channelService(url+buildParameters(filters, url)).then((response) => dispatch(updateAssets(response.data)))
}
export const getContentFromChannel = (url, filters)=> dispatch =>{
    dispatch(setIsLoading(true));
    return Api.content(url, filters.p - 1, null, 6, null).then(response=>{
        dispatch(updateAssets({'hydra:member': response.data}))
    });
}